import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

const UseFormSwitchList = ({
  title,
  field,
  register,
  options,
  setValue,
  watch,
  disabled = false,
  source = "",
}) => {
  useEffect(() => {
    register(field);
  }, [field, register]);

  const value = disabled && source === "role management" ? "" : watch(field);

  useEffect(() => {
    if (disabled && source === "role management") {
      setValue(field, "");
    }
  }, [disabled]);

  return (
    <BasicSwitchList
      options={options}
      title={title}
      onChange={(resp) => setValue(field, resp)}
      // value={watch(field)}
      value={value}
      disabled={disabled}
    />
  );
};

export default UseFormSwitchList;
const BasicSwitchList = ({
  options,
  onChange,
  title,
  value,
  disabled,
}) => {
  const handleModuleChange = (insertValue, checked) => {
    const parseInitialValues = (valueString) => {
      return valueString?.split(":")?.map((innerValue) => innerValue) || [];
    };
    let updatedArr = JSON.parse(JSON.stringify(parseInitialValues(value)));
    if (updatedArr.includes(insertValue)) {
      updatedArr = updatedArr.filter((element) => element !== insertValue);
      onChange(updatedArr.join(":"));
    } else {
      updatedArr = [...updatedArr, insertValue];
      onChange(updatedArr.join(":"));
    }
  };
  const parseInitialValues = (valueString) => {
    return valueString?.split(":")?.map((innerValue) => innerValue) || [];
  };
  return (
    <div>
      <h6 className="mb-4">{title}</h6>
      {options.map((module) => (
        <Form.Check
          key={module.value}
          type="switch"
          id={`switch-${module.value}`}
          label={module.label}
          onChange={(e) =>
            handleModuleChange(module.value.toString(), e.target.checked)
          }
          checked={
            parseInitialValues(value).includes(module.value.toString()) || false
          }
          disabled={disabled}
        />
      ))}
    </div>
  );
};
